import React from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { Box } from '@mui/material';

import styles from './ProgressRing.module.css';
export interface ProgressRingProps {
  value: number;
}

export const ProgressRing: React.FC<ProgressRingProps> = ({ value }) => {
  return (
    <Box position="relative" display="inline-flex">
      <Box position="relative" display="inline-flex">
        <CircularProgress
          className={styles['percent-box']}
          size="5rem"
          thickness={3.0}
          variant="determinate"
          value={100}
          sx={{
            color: (theme) =>
              theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
          }}
        />
        <CircularProgress
          className={styles['progress-ring']}
          size="5rem"
          thickness={3.0}
          variant="determinate"
          value={value}
        />
      </Box>
      <Box className={styles['percent-box']}>
        <Typography variant="caption" component="div">{`${Math.round(
          value
        )}%`}</Typography>
      </Box>
    </Box>
  );
};
